import {Grid, GridItem} from 'platform/foundation';

import {ElementRenderer} from '../components/ElementRenderer';
import {FullSchema} from '../types/FullSchema';
import {RowRendererResponseBody} from '../types/modelSchema';

const DEFAULT_COLUMNS = 4;

export function RowRenderer(props: RowRendererResponseBody) {
  return (
    <Grid columns={props.columns ?? DEFAULT_COLUMNS} align="flex-end">
      {props.elements?.map(({columnSpan, ...element}) => (
        <GridItem key={element.name} span={columnSpan ?? undefined}>
          <ElementRenderer
            isReadOnly={props.isReadOnly}
            rendererRegistry={props.rendererRegistry}
            schema={element as FullSchema}
          />
        </GridItem>
      ))}
    </Grid>
  );
}
